<template>

    <div class="credit-proposal-information-component">

        <!-- Introduction -->
        <div class="introduction">
            <div class="row">
                <div class="col-12">
                    <h3>{{ sectionThreeHeading }}</h3>
                    <div v-html="description"></div>
                </div>
            </div>
        </div>


        <div v-if="quote && policies" class="financial-details">
            <template v-for="(policy, index) in policies">
                <div class="row">
                    <div class="col-12">

                        <h3>{{ policy.title }}</h3>
                        <p>{{ policy.description }}</p>

                        <h4>{{ policy.key_points_heading }}</h4>
                        <div v-html="policy.key_points"></div>

                        <div class="agree mb-0" v-if="policy.declaration_required === '1'">
                            <input type="checkbox" name="confirm_2" v-bind:id="'confirm_'+index"
                                v-model="confirmations[policy.title]" class="confirm">
                            <label v-bind:for="'confirm_'+index">{{ policy.declaration_text }}</label>
                        </div>

                    </div>
                </div>
            </template>

        </div>
    </div>

</template>

<script>
import {EventBus} from '@/event-bus.js';

export default {
    name: 'bch-order-details-component',
    props: [
        'session',
        'submit-order',
        'confirmations',
        'quote',
        'driverProfile',
        'adminPortalData',
        'sectionThreeHeading',
        'currentProduct',
    ],

    data: () => {
        return {};
    },

    async beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        }

        // This is called again when we do the order ID redirect after the order is confirmed so filter those out
        if (to.name === 'Business Contract Hire Order Status' && !to.params.orderId) {
            EventBus.$emit('loadingTitle', 'Submitting Order');
            EventBus.$emit('loading', true);

            // Submit the order
            this.$http.post('/api/quotation', {
                    method: 'POST',
                    endpoint: 'orders',
                    body_params: {
                        customerOrderRef: this.driverProfile.driverID + '-' + Date.now(),
                        quotes: [
                            {
                                quoteID: this.quote.quoteID,
                                quantity: 1
                            }
                        ]
                    }
                })
                .then(response => {

                    const orderId = response.data.data[0].orderID;

                    // Trigger the notification
                    this.$http.post('/api/notifications/send-order', {
                            orderId: orderId
                        })
                        .then(response => {
                            EventBus.$emit('loading', false);

                            this.$router.push({ name: 'Order Status', params: { orderId: orderId } })

                            next();
                        })
                        .catch(err => {
                            EventBus.$emit('loading', false);
                            let response = err.response.data;

                            this.$notify({
                                group: 'notify',
                                type: 'error',
                                title: 'Error',
                                text: response.message
                            });
                            this.error = err.message.toString();
                            this.$router.push({name: response.redirect});
                        });

                })
                .catch(err => {
                    EventBus.$emit('loading', false);
                    let response = err.response.data;

                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: 'Error',
                        text: response.message
                    });
                    this.error = err.message.toString();
                    this.$router.push({name: response.redirect});
                });

        } else {
            next();
        }
    },

    methods: {
        stringToKey(string) {
            return string.replace(/\ /g, '_');
        },
        getInCurrency(value, currency = '£') {
            return currency + Number(value).toFixed(2);
        },
    },

    computed: {
        description() {
            return this.adminPortalData?.content ? this.adminPortalData.content.products.bch[0].order_stage_three_section_three_description : '';
        },
        policies() {
            return this.currentProduct.order_stage_three_policies;
        }
    },
    watch: {
        confirmations: {
            handler(confirmations) {
              EventBus.$emit('setConfirmations', confirmations);
            },
            deep: true,
        },
    },
};
</script>


